module.exports = __webpack_public_path__ + "static/media/We Won't Survive.3661c1ab.jpg";